var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "#EFE8FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#EFE8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 11.5H9V10C9 9.86739 8.94732 9.74021 8.85355 9.64645C8.75979 9.55268 8.63261 9.5 8.5 9.5C8.36739 9.5 8.24021 9.55268 8.14645 9.64645C8.05268 9.74021 8 9.86739 8 10V20C8 20.1326 8.05268 20.2598 8.14645 20.3536C8.24021 20.4473 8.36739 20.5 8.5 20.5C8.63261 20.5 8.75979 20.4473 8.85355 20.3536C8.94732 20.2598 9 20.1326 9 20V18H22V20C22 20.1326 22.0527 20.2598 22.1464 20.3536C22.2402 20.4473 22.3674 20.5 22.5 20.5C22.6326 20.5 22.7598 20.4473 22.8536 20.3536C22.9473 20.2598 23 20.1326 23 20V14C23 13.337 22.7366 12.7011 22.2678 12.2322C21.7989 11.7634 21.163 11.5 20.5 11.5ZM9 12.5H13.5V17H9V12.5ZM14.5 17V12.5H20.5C20.8978 12.5 21.2794 12.658 21.5607 12.9393C21.842 13.2206 22 13.6022 22 14V17H14.5Z",
    fill: "#7F43FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotels);
export default __webpack_public_path__ + "static/media/Hotels.97389c0b777ea73bbd4e578c981039ee.svg";
export { ForwardRef as ReactComponent };